$bog_bzrl_app_filter $mol_view
	search? null
	sub /
		<= District_block $mol_view
			sub /
				<= District $mol_select
					value? <=> district? \all
					Filter null
					Trigger_icon <= District_icon $mol_icon_chevron_down
					dictionary *
						all @ \New builds
						vahitovsky @ \Vakhitovsky
						sovetsky @ \Sovetsky
						novo_savinovsky @ \Novo-Savinovsky
		<= Rooms_block $mol_view
			sub /
				<= Rooms $mol_switch
					value? <=> rooms? \studio
					options *
						studio @ \Studio
						r1 \1
						r2 \2
						r3 \3
						r4 \4+
		<= Price_block $mol_view
			sub /
				<= Price_from $mol_string
					hint @ \Price from
					value? <=> price_from? \
		<= Search_block $mol_view
			sub /
				<= Search $mol_button_major
					click? <=> search? null
					sub /
						<= search_label @ \View apartments
